//General
export const OYO_FORM_BIG_IMAGE =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/oyo_big_image_MOBILE.jpg';

export const TRIANGLE =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/Triangle.svg';
export const THANKS_TICK =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/ThanksTick.svg';
export const OYO_ICON =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/oyo_icon.png';
export const LANDING =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/landing.png';
export const BECOME_AN_OYO =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/oyo_big_image.jpg';
export const BACK_BUTTON =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/back.svg';
export const BACK_BLACK_BUTTON =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/back_black.svg';
export const NEXT_BUTTON =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/next.svg';
export const DOWN_ARROW =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/down_arrow.svg';
export const READY_TO_GET_STARTED =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/partner_join_us_world_v2.gif';

export const DESKTOP_APPLE_APP_STORE =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/app-store-apple-.png';
export const DESKTOP_PLAYSTORE =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/playstore.png';
export const OYO_WHITE =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/OYO_white.png';
export const YOUTUBE =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/youtube%403x.png';
export const TWITTER =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/twitter%403x.png';
export const PINTEREST =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/pinterest%403x.png';
export const INSTAGRAM =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/instagram%403x.png';
export const FACEBOOK =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/facebook.png';
export const FLAGS =
  'https://assets.oyoroomscdn.com/webv1/desktop_assets/images/countryFlags.85b76fa7ac7e664d.png';
//Why OYO
export const ASSET_MANAGEMENT =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/AssetManagemnt.svg';
export const ASSET_TRANSFORMATION =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/AssetTransformation.svg';
export const CAPTAIN =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/OYOCaptain.svg';
export const VISIBILITY =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/Visibility.svg';
export const TIE_UPS =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/Corporatetie-ups.svg';

//Programs
export const FINANCIAL_SUPPORT =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/FinancialSupport.png';
export const ASSET_UPGRADATION =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/AssetUpgradation.png';
export const REFERRAL =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/Referral.png';
export const VAS =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/VAS.png';

//Steps
export const STEP_1 =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/Step1.svg';
export const STEP_2 =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/Step2.svg';
export const STEP_3 =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/Step3.svg';
export const STEP_4 =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/Step4.svg';

export const APPSTORE_DOWNLOAD =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/download_appstore.png';

export const PLAYSTORE_DOWNLOAD =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/pstore.png';

export const MENU_ICON =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/menu_icon.png';

export const FAVICON =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/favicon.png';

export const PLAY_STORE_MOBILE =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/play_store_mobile.svg';

export const TWITTER_MOBILE =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/twitter_mobile.svg';

export const INSTAGRAM_MOBILE =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/instagram_mobile.svg';

export const FACEBOOK_MOBILE =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/facebook_mobile.svg';

export const SLIDER_ONE =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/slider_1.png';

export const THUMB_ONE =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/thumb_one.jpg';

export const THUMB_TWO =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/thumb_two.jpg';

export const THUMB_THREE =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/thumb_three.jpg';

export const oyo_townhouse =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/oyo_townhouse.png';

export const oyo_hotels =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/oyo_hotels.jpg';

export const oyo_hostels =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/oyo_hostels.jpg';

export const oyo_homes =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/oyo_homes.jpg';

export const oyo_silverkey =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/oyo_silverkey.jpg';

export const oyo_x =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/oyo_x.jpg';

export const oyo_flagship =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/oyo_flagship.jpg';

export const oyo_design =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/oyo_design.jpg';

export const capital_o =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/capital_o.jpg';

export const collection_o =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/collection_o.jpg';

export const premium =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/premium.jpg';

export const co_works =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/co_works.jpg';

export const LANDING_SIZE_ADAPTIVE_PREFIX =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/landing';

export const LANDING_SIZE_ADAPTIVE_SUFFIX = '.png';

// TODO: Replace with keys
export const BACK_VID = {
  Desktop:
    'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/back_vid_desktop.mp4',
  Mobile:
    'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/back_vid_mobile.mp4'
};

export const JOIN_US_ICON =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/join_us_icon.svg';

export const PTYPE_ICON =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/ptype_icon.svg';

export const HOME_ICON =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/home_icon.svg';

export const ARROW_LEFT_ICON =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/arrow-left.svg';

export const call =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/ic_call.png';

export const email =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/ic_email.png';

// FOOTER
export const OYO_footer_logo =
  'https://prod-disc-disc-part.s3-ap-southeast-1.amazonaws.com/footer_oyo_logo.png';
